var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomBlock9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 200,
    fill: "#F6F6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_2665)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    transform: "translate(0 44)",
    fill: "#B5C3E5"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 44,
    width: 400,
    height: 112,
    fill: "#F6F6FB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -152.735,
    y1: 49.6568,
    x2: 164.049,
    y2: -267.127,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -145.664,
    y1: 56.7279,
    x2: 171.12,
    y2: -260.056,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -138.593,
    y1: 63.7989,
    x2: 178.191,
    y2: -252.985,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -131.522,
    y1: 70.87,
    x2: 185.262,
    y2: -245.914,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -124.451,
    y1: 77.941,
    x2: 192.333,
    y2: -238.843,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.38,
    y1: 85.0121,
    x2: 199.404,
    y2: -231.772,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -110.309,
    y1: 92.0831,
    x2: 206.475,
    y2: -224.701,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -103.238,
    y1: 99.1541,
    x2: 213.546,
    y2: -217.63,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -96.1664,
    y1: 106.225,
    x2: 220.617,
    y2: -210.558,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -89.0954,
    y1: 113.296,
    x2: 227.688,
    y2: -203.487,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -82.0243,
    y1: 120.368,
    x2: 234.76,
    y2: -196.416,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -74.9533,
    y1: 127.439,
    x2: 241.831,
    y2: -189.345,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -67.8822,
    y1: 134.51,
    x2: 248.902,
    y2: -182.274,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.8112,
    y1: 141.581,
    x2: 255.973,
    y2: -175.203,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -53.7401,
    y1: 148.652,
    x2: 263.044,
    y2: -168.132,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -46.6691,
    y1: 155.723,
    x2: 270.115,
    y2: -161.061,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.5981,
    y1: 162.794,
    x2: 277.186,
    y2: -153.99,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -32.527,
    y1: 169.865,
    x2: 284.257,
    y2: -146.919,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.456,
    y1: 176.936,
    x2: 291.328,
    y2: -139.848,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.3847,
    y1: 184.007,
    x2: 298.399,
    y2: -132.777,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -11.3136,
    y1: 191.078,
    x2: 305.47,
    y2: -125.706,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.24258,
    y1: 198.149,
    x2: 312.541,
    y2: -118.635,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.82846,
    y1: 205.22,
    x2: 319.612,
    y2: -111.564,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.89951,
    y1: 212.291,
    x2: 326.683,
    y2: -104.493,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.9706,
    y1: 219.362,
    x2: 333.754,
    y2: -97.4215,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.0416,
    y1: 226.433,
    x2: 340.825,
    y2: -90.3504,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.1126,
    y1: 233.504,
    x2: 347.897,
    y2: -83.2794,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.1837,
    y1: 240.576,
    x2: 354.968,
    y2: -76.2083,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.2547,
    y1: 247.647,
    x2: 362.039,
    y2: -69.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.326,
    y1: 254.718,
    x2: 369.11,
    y2: -62.0662,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.3971,
    y1: 261.789,
    x2: 376.181,
    y2: -54.9949,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66.4681,
    y1: 268.86,
    x2: 383.252,
    y2: -47.9239,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.5392,
    y1: 275.931,
    x2: 390.323,
    y2: -40.8529,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.6102,
    y1: 283.002,
    x2: 397.394,
    y2: -33.7818,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.6812,
    y1: 290.073,
    x2: 404.465,
    y2: -26.7108,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.7523,
    y1: 297.144,
    x2: 411.536,
    y2: -19.6397,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.823,
    y1: 304.215,
    x2: 418.607,
    y2: -12.5687,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.894,
    y1: 311.286,
    x2: 425.678,
    y2: -5.49763,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.965,
    y1: 318.357,
    x2: 432.749,
    y2: 1.57341,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.036,
    y1: 325.429,
    x2: 439.82,
    y2: 8.6447,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.108,
    y1: 332.499,
    x2: 446.892,
    y2: 15.7155,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.179,
    y1: 339.571,
    x2: 453.963,
    y2: 22.7868,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.25,
    y1: 346.642,
    x2: 461.034,
    y2: 29.8578,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.321,
    y1: 353.713,
    x2: 468.105,
    y2: 36.9289,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158.392,
    y1: 360.784,
    x2: 475.176,
    y2: 43.9999,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.463,
    y1: 367.855,
    x2: 482.247,
    y2: 51.071,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.534,
    y1: 374.926,
    x2: 489.318,
    y2: 58.142,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.605,
    y1: 381.997,
    x2: 496.389,
    y2: 65.2131,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.676,
    y1: 389.068,
    x2: 503.46,
    y2: 72.2841,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.747,
    y1: 396.139,
    x2: 510.531,
    y2: 79.3551,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200.818,
    y1: 403.21,
    x2: 517.602,
    y2: 86.4264,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.889,
    y1: 410.281,
    x2: 524.673,
    y2: 93.4972,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.961,
    y1: 417.352,
    x2: 531.744,
    y2: 100.569,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 222.032,
    y1: 424.423,
    x2: 538.815,
    y2: 107.64,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.103,
    y1: 431.494,
    x2: 545.886,
    y2: 114.711,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.174,
    y1: 438.566,
    x2: 552.958,
    y2: 121.782,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.245,
    y1: 445.637,
    x2: 560.029,
    y2: 128.853,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.316,
    y1: 452.708,
    x2: 567.1,
    y2: 135.924,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.387,
    y1: 459.779,
    x2: 574.171,
    y2: 142.995,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.458,
    y1: 466.85,
    x2: 581.242,
    y2: 150.066,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271.529,
    y1: 473.921,
    x2: 588.313,
    y2: 157.137,
    stroke: "#B6C2E5",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.706 112.389C112.931 112.389 111.276 112.097 109.74 111.513C108.225 110.907 106.894 110.063 105.748 108.981C104.601 107.9 103.703 106.634 103.054 105.184C102.426 103.713 102.112 102.122 102.112 100.413C102.112 98.6817 102.426 97.0913 103.054 95.6415C103.703 94.1918 104.59 92.9368 105.715 91.8765C106.862 90.8162 108.193 89.994 109.707 89.4097C111.222 88.8039 112.866 88.5009 114.641 88.5009C116.437 88.5009 118.081 88.7822 119.574 89.3448C121.067 89.9074 122.366 90.6864 123.469 91.6817L119.152 96.031C118.633 95.4684 117.995 95.0248 117.237 94.7003C116.502 94.3757 115.636 94.2134 114.641 94.2134C113.775 94.2134 112.975 94.3541 112.239 94.6353C111.525 94.9166 110.908 95.3278 110.389 95.8687C109.87 96.4097 109.458 97.0696 109.156 97.8486C108.874 98.6059 108.734 99.4606 108.734 100.413C108.734 101.386 108.874 102.263 109.156 103.042C109.458 103.799 109.87 104.448 110.389 104.989C110.908 105.53 111.525 105.952 112.239 106.255C112.975 106.536 113.775 106.677 114.641 106.677C115.614 106.677 116.48 106.525 117.237 106.223C118.016 105.92 118.687 105.476 119.25 104.892L123.599 109.241C122.452 110.236 121.165 111.015 119.737 111.578C118.308 112.119 116.631 112.389 114.706 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.852 112.389C134.818 112.389 133.043 111.978 131.529 111.156C130.014 110.312 128.835 109.155 127.991 107.683C127.147 106.212 126.725 104.524 126.725 102.62V88.8904H133.216V103.204C133.216 103.94 133.379 104.567 133.703 105.087C134.028 105.606 134.461 106.006 135.002 106.287C135.564 106.547 136.181 106.677 136.852 106.677C137.544 106.677 138.15 106.547 138.669 106.287C139.21 106.006 139.632 105.617 139.935 105.119C140.238 104.6 140.389 103.972 140.389 103.236V88.8904H146.913V102.652C146.913 104.556 146.491 106.244 145.647 107.716C144.825 109.165 143.657 110.312 142.142 111.156C140.649 111.978 138.886 112.389 136.852 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.827 112.389C156.858 112.389 155.138 112.108 153.666 111.546C152.216 110.961 150.875 110.042 149.641 108.787L153.699 104.73C154.543 105.53 155.43 106.147 156.36 106.58C157.291 106.991 158.286 107.196 159.346 107.196C160.233 107.196 160.904 107.066 161.359 106.807C161.813 106.525 162.04 106.147 162.04 105.671C162.04 105.195 161.845 104.805 161.456 104.502C161.066 104.178 160.547 103.896 159.898 103.658C159.27 103.399 158.567 103.139 157.788 102.879C157.031 102.62 156.274 102.306 155.516 101.938C154.759 101.57 154.056 101.127 153.407 100.607C152.779 100.067 152.271 99.4065 151.881 98.6276C151.492 97.827 151.297 96.8533 151.297 95.7064C151.297 94.2134 151.654 92.9259 152.368 91.844C153.082 90.7621 154.088 89.9399 155.386 89.3773C156.685 88.7931 158.21 88.5009 159.963 88.5009C161.694 88.5009 163.295 88.7822 164.767 89.3448C166.26 89.8858 167.493 90.6648 168.467 91.6817L164.377 95.7389C163.663 95.0465 162.949 94.538 162.235 94.2134C161.521 93.8672 160.742 93.6941 159.898 93.6941C159.227 93.6941 158.686 93.8023 158.275 94.0187C157.886 94.235 157.691 94.5596 157.691 94.9924C157.691 95.4468 157.886 95.8254 158.275 96.1284C158.665 96.4097 159.173 96.6693 159.801 96.9073C160.45 97.1454 161.153 97.3942 161.91 97.6539C162.689 97.9135 163.457 98.2273 164.215 98.5951C164.972 98.9413 165.664 99.3957 166.292 99.9583C166.941 100.499 167.46 101.181 167.85 102.003C168.239 102.825 168.434 103.821 168.434 104.989C168.434 107.348 167.59 109.176 165.903 110.474C164.236 111.751 161.878 112.389 158.827 112.389Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.227 112V88.8904H183.719V112H177.227ZM170.314 94.4081V88.8904H190.665V94.4081H170.314Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.909 112.454C203.091 112.454 201.414 112.151 199.878 111.546C198.363 110.94 197.032 110.096 195.886 109.014C194.76 107.932 193.884 106.655 193.257 105.184C192.629 103.713 192.315 102.122 192.315 100.413C192.315 98.6817 192.618 97.0913 193.224 95.6415C193.852 94.1918 194.728 92.9259 195.853 91.844C196.978 90.7621 198.298 89.9291 199.813 89.3448C201.349 88.739 203.026 88.436 204.844 88.436C206.661 88.436 208.327 88.739 209.842 89.3448C211.378 89.9291 212.709 90.7621 213.834 91.844C214.96 92.9259 215.825 94.2026 216.431 95.674C217.058 97.1237 217.372 98.7141 217.372 100.445C217.372 102.155 217.058 103.745 216.431 105.216C215.825 106.666 214.96 107.943 213.834 109.046C212.709 110.128 211.389 110.972 209.875 111.578C208.36 112.162 206.705 112.454 204.909 112.454ZM204.844 106.742C206.055 106.742 207.105 106.482 207.992 105.963C208.879 105.444 209.561 104.708 210.037 103.756C210.513 102.804 210.751 101.689 210.751 100.413C210.751 99.4606 210.61 98.6059 210.329 97.8486C210.069 97.0696 209.68 96.4097 209.161 95.8687C208.641 95.3061 208.014 94.8842 207.278 94.6029C206.564 94.3 205.753 94.1485 204.844 94.1485C203.632 94.1485 202.583 94.4081 201.695 94.9275C200.808 95.4251 200.127 96.15 199.651 97.1021C199.175 98.0325 198.937 99.1361 198.937 100.413C198.937 101.386 199.066 102.263 199.326 103.042C199.607 103.821 200.008 104.492 200.527 105.054C201.046 105.595 201.663 106.017 202.377 106.32C203.113 106.601 203.935 106.742 204.844 106.742Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.344 112V88.8904H226.05L234.651 101.484H232.606L241.175 88.8904H245.881V112H239.455V99.5364L240.396 99.796L235.69 106.547H231.535L226.861 99.796L227.77 99.5364V112H221.344Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.482 112L270.507 88.8904H275.57L271.513 112H266.482ZM257.102 105.736V101.516H276.382V105.736H257.102ZM258.855 112L262.912 88.8904H267.91L263.918 112H258.855ZM258.27 98.8872V94.7003H277.518V98.8872H258.27Z",
    fill: "#2C314F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.309 112L290.066 101.289L292.5 101.808C292.132 102.349 291.775 102.815 291.429 103.204C291.105 103.594 290.704 103.896 290.228 104.113C289.752 104.329 289.103 104.437 288.281 104.437C286.788 104.437 285.425 104.091 284.191 103.399C282.98 102.685 282.006 101.743 281.27 100.575C280.556 99.3849 280.199 98.065 280.199 96.6152C280.199 95.0789 280.589 93.7049 281.368 92.4932C282.168 91.2598 283.239 90.2861 284.581 89.572C285.944 88.858 287.469 88.5009 289.157 88.5009C290.867 88.5009 292.392 88.858 293.734 89.572C295.075 90.2861 296.136 91.2598 296.914 92.4932C297.715 93.7049 298.115 95.0789 298.115 96.6152C298.115 98.4328 297.488 100.261 296.233 102.1L289.514 112H282.309ZM289.157 99.7311C289.698 99.7311 290.174 99.6121 290.585 99.3741C291.018 99.1144 291.354 98.7682 291.592 98.3355C291.83 97.8811 291.949 97.3726 291.949 96.81C291.949 96.2474 291.83 95.7497 291.592 95.3169C291.354 94.8625 291.018 94.5163 290.585 94.2783C290.174 94.0187 289.698 93.8888 289.157 93.8888C288.616 93.8888 288.129 94.0187 287.697 94.2783C287.286 94.5163 286.961 94.8625 286.723 95.3169C286.485 95.7497 286.366 96.2474 286.366 96.81C286.366 97.3726 286.485 97.8811 286.723 98.3355C286.961 98.7682 287.286 99.1144 287.697 99.3741C288.129 99.6121 288.616 99.7311 289.157 99.7311Z",
    fill: "#2C314F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_2665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 112,
    fill: "white",
    transform: "translate(0 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomBlock9);
export default __webpack_public_path__ + "static/media/custom-block-9.23f8b18109e59e6f577cef8829513051.svg";
export { ForwardRef as ReactComponent };